export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;
export const WEEK_MS = 7 * DAY_MS;

export function isoDate(at: Date): string {
  return at.toISOString().slice(0, 10);
}

export function addMonths(at: Date, months: number): Date {
  const next = new Date(at);
  next.setUTCMonth(next.getUTCMonth() + months);
  return next;
}

export const PLAN_REVIEW_MONTHS = 6;

export function planReviewDate(now: Date): string {
  return isoDate(addMonths(now, PLAN_REVIEW_MONTHS));
}
